/**
 * Test IDs for QA automation.
 */
export const testIds = {
  shipmentLocationFormReceiver: "shipment-location-form-receiver",
  shipmentLocationFormOpen: "shipment-location-form-open",
} as const;
